import { savePdf } from '../../utils/pdfDocument';
import { orderSheetParts } from './orderSheet';

/** The order sheet Print makes, saved as "<order number>.pdf" in the browser's downloads. */
export const saveOrderPdf = (order, branding) => {
  const { styles, bodyHtml } = orderSheetParts(order, branding);
  return savePdf({ title: `Purchase order ${order.orderNumber}`, fileName: order.orderNumber, styles, bodyHtml });
};
